<div class="bg-container"></div>
<div class="container-fluid bg-img">
  <div class="form-card">
    <div class=" text-center">
      <img class="logo" src="../../../../assets/Partanalytics_logo_white.svg" alt="PartAnalytics" />
      @if(isAltiumLoginError) {
      <div class="card p-3">
        <div>
          <h2><i class="fa fa-exclamation-circle" style="color: orange;" aria-hidden="true"></i></h2>
          <h4>Invalid Authentication</h4>
          <h6>
            {{params?.error_description}}
          </h6>
          <button class="btn btn-primary mt-2 w-75" [routerLink]="['/oAuth/login']">
            Back to Login
          </button>
        </div>
      </div>
      }
    </div>
  </div>
</div>